export default function captionConvertion() {
    function convertSrtToJson(file) {
        let json = [];
        let blocks = file.trim().split(/\r\n\r\n|\n\n|\r\r/); // Split subtitle blocks;
        blocks.forEach((block) => {
            var lines = block.trim().split(/\r\n|\n|\r/);
            if (lines.length >= 2) {
                let subtitle = {};
                subtitle['id'] = Number(lines.shift());
                let timeLine = lines.shift();
                if (timeLine.indexOf('-->') !== false) {
                    const [start, end] = timeLine.split('-->');
                    subtitle['start_time'] = start.trim().replace(',', '.');
                    subtitle['end_time'] = end.trim().replace(',', '.');
                }
                subtitle['text'] = lines.join('\n');
                json.push(subtitle);
            }
        })

        return json;
    }

    function convertJsonToVtt(captions) {
        let vtt_text = "WEBVTT\n\n";
        captions.forEach((caption) => {
            let start = formatTimeForVtt(caption['start_time']);
            let end = formatTimeForVtt(caption['end_time']);
            vtt_text += `${start} --> ${end}\n${caption['text']}\n\n`;
        })

        return vtt_text;
    }

    function formatTimeForVtt(time) {
        // Convert time like "1.5" to "00:00:01.500"
        let parts = String(time).split('.');
        let seconds = Number(parts[0]);
        let milliseconds = parts[1] ? parts[1].substr(0, 3).padEnd(3, '0') : '000';
        // let milliseconds = parts[1] ? str_pad(substr(parts[1], 0, 3), 3, '0') : '000';

        let hours = String(Math.floor(seconds / 3600)).padStart(2, '0');
        let minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
        let secs = String(seconds % 60).padStart(2, '0');

        return `${hours}:${minutes}:${secs}.${milliseconds}`;
    }

    function convertJsonToSrt(captions) {
        let srt_text = "";
        captions.forEach((caption, index) => {
            index = index + 1;
            let start = formatTimeForVtt(caption['start_time']);
            let end = formatTimeForVtt(caption['end_time']);
            var data = `${index}\n${(start).replace('.', ',')} --> ${(end).replace('.', ',')}`;
            srt_text = `${srt_text}\n${data}\n${caption['text']}\n`;
        })
        return srt_text;
    }

    return {
        convertSrtToJson,
        convertJsonToVtt,
        convertJsonToSrt
    };
}